<template>
  <router-view :key="$route.params"></router-view>
  <ModalSessionTimeout
    :show="showSessionTimeout"
    @login="goToLogin"
  />
</template>
<script>
import AOS from "aos";
import idleSession from "@/applibs/idleSession.js";
import ModalSessionTimeout from "@/components/modals/ModalSessionTimeout.vue";

export default {
  components: { ModalSessionTimeout },

  data() {
    return {
      showSessionTimeout: false,
    };
  },

  sockets: {
    connect: function () {
      // PERHATIAN: JANGAN DI COMMENT LOG INI KARENA DI PRODUCTION AKAN MENYEBABKAN ERROR
      console.log("socket to CBC connected");
    },

    disconnect: function () {
      console.log("socket disconnected - App");
    },
  },

  watch: {
    $route() {
      this.syncIdleSession();
    },
  },

  mounted() {
    AOS.init();
    this.syncIdleSession();
  },

  beforeUnmount() {
    idleSession.stop();
    document.body.style.removeProperty("overflow");
  },

  methods: {
    syncIdleSession() {
      var self = this;
      idleSession.sync(function () {
        self.showSessionTimeout = true;
        document.body.style.overflow = "hidden";
      });
    },

    goToLogin() {
      idleSession.clearHomeRedirectFlag();
      this.showSessionTimeout = false;
      document.body.style.removeProperty("overflow");
      this.$router.replace("/auth/login");
    },
  },
};
</script>
